class DraggableHelper {
  constructor() {
    this.fromRef;
    this.data;
    this.serialized;
  }
}

export default new DraggableHelper();
